  <template>
  <div v-role="'adm'">
   <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
  <v-data-table
    :headers="headers"
    :items="desserts"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
         <v-chip
            class="ma-4"
            color="primary"
            outlined
            pill
          >
            Painel de Usuários : Funcionário
            <v-icon right>lock</v-icon>
          </v-chip>

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>
<span color="green"><strong style="color:green">Activos: </strong>{{quantUsuariosActivos}} <strong style="color:red">Inactivos: </strong>{{quantUsuariosInativos}}</span>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="initialize(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="1000px">
          <v-card v-if="!save_status">
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col v-if="false" cols="12" sm="12" md="6">
                      <v-text-field

                        v-model="editedItem.idFuncionario"
                        label="cod"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                        <v-text-field

                        v-model="editedItem.nomeUsuario"
                        label="Nome"
                        :disabled=true
                        :rules="ruleNome"
                      ></v-text-field>

                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.username"
                        label="Email"
                        :rules="ruleEmailRequired"
                      ></v-text-field>

                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                        <v-select v-if="role === 'ROLE_ADM'"
                                  :items="rolesADM"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  :disabled="disabilitaRole"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_DIR'"
                                  :items="rolesDir"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  :disabled="disabilitaRole"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_FUNC'"
                                  :items="rolesFun"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  :disabled="disabilitaRole"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_PED'"
                                  :items="rolesPed"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  :disabled="disabilitaRole"
                                  dense
                        ></v-select>

                        <v-select v-if="role === 'ROLE_PWR'"
                                  :items="rolesPWR"
                                  v-model="editedItem.autorizacoes_nome"
                                  :rules="obrigqtorioRules"
                                  label="Role"
                                  :disabled="disabilitaRole"
                                  dense
                        ></v-select>

                    </v-col>

                     <v-col cols="12" sm="12" md="4">
                       <v-text-field

                        v-model="editedItem.passwordnew"
                         :rules="obrigqtorioRules"
                        label="Password"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2">
                          <!--  <v-btn class="mx-2" fab dark md color="pink"
                            hint="teste"
                           >
                             <v-icon dark>lock</v-icon>
                          </v-btn> -->

                          <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn class="mx-2" fab dark md color="pink" v-on="on" @click="GeradorSenha()">
                              <v-icon dark>lock</v-icon>
                          </v-btn>
                        </template>
                        <span>Gerador automático  de senha</span>
                      </v-tooltip>
                     </v-col>

 <v-col cols="12" sm="12" md="6">
            <v-switch  v-if="editedItem.enable" v-model="editedItem.enable"   label="Activa"></v-switch>
            <v-switch  v-if="!editedItem.enable"  v-model="editedItem.enable"   label="Inactiva"></v-switch>
  </v-col>

                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
               <v-row>
                   <v-col md="10"></v-col>
                      <v-col md="2" v-if="progresso">
                        <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                      ></v-progress-circular>
                      </v-col>

                </v-row>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
          <v-card v-if="save_status">
             <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
                {{ $store.state.textMessage }}
              </div>
            <v-card-actions>
             <v-col md="8">
                           <p>Password: <span style="color:red;font-size:32px;">{{editedItem.passwordnew}}</span> <br> Guarde esta senha e forneça ao respectivo usuário</p>
                      </v-col>
               <v-btn color="blue darken-1" text @click="close">Ja guardei a senha, fechar</v-btn>
           </v-card-actions>
          </v-card>

        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.ver_status="{ item }">
     <span style="color:red;" v-if="item.activo === 'inactiva'" >{{item.activo}}</span>
     <span style="color:green;" v-if="item.activo === 'activa'">{{item.activo}}</span>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon :disabled="role_activo !=='ROLE_ADM'  && (item.autorizacoes_nome === 'ROLE_ADM' || item.autorizacoes_nome === 'ROLE_DIR') " color="green darken-3" small class="mr-2" @click="editItem(item)">edit</v-icon>
     <v-icon   color="red darken-3" small class="mr-2" @click="deleteItem(item)" v-if="false">delete</v-icon>
    </template>

    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
  </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
let generator = require('generate-password')
export default {
  data: () => ({

    text: '',
    flag_curso: '',
    disabilitaRole: false,
    role_activo: ls.get('role'),
    save_status: false,
    formValid: true,
    rolesFun: [ 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF' ],
    // eslint-disable-next-line standard/array-bracket-even-spacing
    rolesPed: [ 'ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF'],
    rolesDir: ['ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF', 'ROLE_PWR'],
    rolesPWR: ['ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF', 'ROLE_PWR'],
    rolesADM: ['ROLE_DIR', 'ROLE_ADM', 'ROLE_PED', 'ROLE_COOR', 'ROLE_FUNC', 'ROLE_EST', 'ROLE_PROF', 'ROLE_PWR'],
    search: '',
    disativa: false,
    cursos: [],
    isLoading: false,
    funcionarios: [],
    obrigqtorioRules: [
      value => !!value || 'campo obrigatório.'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'Máximo número de carácteres atigidos',
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],

    ruleNome: [
      value => value.length <= 50 || 'Máximo número de carácteres atigidos',
      value => !!value || 'campo obrigatório.'
    ],

    desserts: [],
    dialog: false,
    progresso: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nomeUsuario'
      },

      { text: 'Cod.', value: 'idPessoa' },
      { text: 'Role', value: 'role_descricao' },
      { text: 'Nome de Usuario', value: 'username' },

      { text: 'Status', value: 'ver_status', sortable: false },
      { text: 'Último login', value: 'data_user' },

      { text: 'Modificado', value: 'data_func' },

      { text: 'Actions', value: 'actions', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idFuncionario: '',
      idPessoa: '', // bi
      email: '',
      nomeUsuario: '',
      autorizacoes_nome: '',
      enable: false,
      idusuario_autorizacao: '',
      newpassword: '',
      professor: 0,
      pkUsuario: 0,
      passwordnew: ''
    },
    defaultItem: {
      idFuncionario: '',
      idPessoa: '', // bi
      email: '',
      nomeUsuario: '',
      autorizacoes_nome: '',
      enable: false,
      idusuario_autorizacao: '',
      newpassword: '',
      professor: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Funcionário' : 'Editar'
    },

    role () {
      return ls.get('role')
    },
    quantUsuariosActivos () {
      return (this.desserts.length > 0 ? this.desserts.filter(t => t.enable === 1).length : 0)
    },
    quantUsuariosInativos () {
      return (this.desserts.length > 0 ? this.desserts.filter(t => t.enable !== 1).length : 0)
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },

  methods: {
    passwordgenerator () {
      let generator = require('generate-password')

      return generator.generate({ length: 4, numbers: true })
    },

    async initialize (search) {
      this.isLoading = true
      try {
        if (!search) {
          var payload = '{"find":"all" , "role":"F"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }

        this.desserts = await axios
          .get('/usuarioFindAllAdmin/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.passwordnew = this.passwordgenerator()
      this.save_status = false
      this.dialog = true
      if (item.autorizacoes_nome === 'ROLE_EST') this.disabilitaRole = true; else this.disabilitaRole = false
    },

    deleteItem (item) {
      console.log(item)
      /* const index = this.desserts.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.desserts.splice(index, 1) */
    },

    GeradorSenha () {
      this.editedItem = Object.assign({}, this.editedItem)
      this.editedItem.passwordnew = this.passwordgenerator()
    },

    async close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        const ls = require('local-storage')
        try {
          var params =
         {
           pkUsuario: this.editedItem.pkUsuario,
           email: this.editedItem.username,
           role: this.editedItem.autorizacoes_nome,
           password: this.editedItem.passwordnew,
           enable: (this.editedItem.enable === true) ? 1 : 0,
           instituicao_descricao: ls.get('instituicaodescricao'),
           nome: this.editedItem.nomeUsuario,
           idPessoa: this.editedItem.idPessoa

         }
        } catch (error) {

        }
        try {
          // eslint-disable-next-line camelcase
          let cor_mensagem = 'msgError'
          let msg = await axios
            .post('/UsuarioInsertOrUpdate', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.dialog = true
          // Verificação da mensagem de erro ou sucesso
          if (msg.length) {
            this.text = 'Ocorreu um erro ao tentar efectuar a operação.'
            // eslint-disable-next-line camelcase
            cor_mensagem = 'msgError'
          } else {
            this.text = 'Operação efectuada com sucesso.'
            // eslint-disable-next-line camelcase
            cor_mensagem = 'msgSucess'
            this.save_status = true
            this.initialize()
          }
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: cor_mensagem,
            timeout: 4000
          })
        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        }
        this.progresso = false
      }
    }
  }
}
</script>
